// Labels for the Deals list, the unified deal page and its thread (ticket 191).
// Keys come straight from the API (RE transaction stages, loan statuses, party
// and thread roles); an unknown key degrades to "Snake case" via labelFor
// rather than showing raw `under_contract` text.
import { LOAN_STATUS_LABELS, PARTY_ROLE_LABELS } from './losApi';
import { STAGES } from './re/stages';
import { labelFor } from './shared/labels';

// One map for every stage/status a deal shows: RE stages and loan statuses
// share keys (prospect, clear_to_close, cancelled) and agree on the label.
export const STAGE_LABELS = {
  ...Object.fromEntries(STAGES.map((s) => [s.key, s.label])),
  ...LOAN_STATUS_LABELS,
};
export const stageLabel = (key) => labelFor(STAGE_LABELS, key);

// Any other snake_case key (contract status, transaction side): "Snake case".
export const humanize = (key) => labelFor(null, key);

// Thread roles (deal_messages_router._deal_staff_roles) plus the loan-file
// party roles the Deal Parties card shows.
export const ROLE_LABELS = {
  ...PARTY_ROLE_LABELS,
  lo: 'Loan Officer',
  agent: 'Realtor',
  realtor: 'Realtor',
  buyer_agent: 'Buyer Agent',
  seller_agent: 'Seller Agent',
  assistant: 'Assistant',
  admin: 'Admin',
  co_borrower: 'Co-Borrower',
  party: 'Title / Escrow',
};
export const roleLabel = (key) => labelFor(ROLE_LABELS, key);

// loan_doc_requests.status, or "uploaded" for a file with no request behind it.
export const DOC_STATUS_LABELS = {
  requested: 'Requested',
  uploaded: 'Uploaded',
  reviewed: 'Reviewed',
  rejected: 'Rejected',
};
export const docStatusLabel = (key) => labelFor(DOC_STATUS_LABELS, key);

// loan_documents.folder (the loan file's Documents tab names).
export const DOC_FOLDER_LABELS = {
  borrower_info: 'Borrower Info',
  asset: 'Assets',
  credit: 'Credit',
  disclosures: 'Disclosures',
  income_emp: 'Income / Employment',
  property: 'Property',
  misc: 'Misc',
};
export const docFolderLabel = (key) => labelFor(DOC_FOLDER_LABELS, key || 'misc');
